// @flow

import * as React from 'react';
import { Link } from 'react-router-dom';
import * as cssUtils from 'app/utils/cssUtils';
import Tappable from 'app/components/commons/Tappable';
import useSheet from 'app/jss';
import classNames from 'classnames';
import Icon from './Icon';

type Props = {
  children: React.Node,
  classes: Object,
  className?: string,
  innerStyle?: Object,
  link?: string,
  onClick?: () => void,
  scheme?: 'light' | 'dark'
};

const defaultProps = {
  className: '',
  innerStyle: undefined,
  link: undefined,
  onClick: undefined,
  scheme: 'light'
};

function BackButton({ children, link, onClick, classes, className, innerStyle, scheme }: Props) {
  return (
    <Tappable
      component={link ? Link : 'span'}
      className={classNames(classes.backButton, className, scheme)}
      onTap={onClick}
      to={link}
    >
      <div className={classes.padding} style={innerStyle}>
        <Icon type="icon-left-arrow" />
        {children}
      </div>
    </Tappable>
  );
}

BackButton.defaultProps = defaultProps;

function applyStyles(theme: Theme) {
  return {
    padding: {
      padding: theme.spacing.medium
    },
    backButton: {
      display: 'flex',
      transition: 'color 0.2s',
      '&.light': {
        color: theme.color.basis6,
        ...cssUtils.hover({
          color: theme.color.basis3
        })
      },
      '&.dark': {
        color: theme.color.basis2,
        ...cssUtils.hover({
          color: theme.color.basis4
        })
      }
    }
  };
}

export default useSheet(applyStyles)(BackButton);
